module.exports = __webpack_public_path__ + "static/media/perc.a715671b.ogg";